import { setSnackbar } from "../../redux/messageSlice";
import { updateTeamState } from "../../redux/teamSlice";
import { updateState } from "../../redux/commonSlice";
import { getTeamEventsListApi } from "../../services/api";



export const getTeamEvents = (values ,dispatch ) => {
  dispatch(updateTeamState({events_loading: true}))
  const payload = values
getTeamEventsListApi(payload) 
.then((response) => {
  dispatch(updateTeamState({events_loading: false}))
  if(response?.data?.http_code === 200){
    dispatch(
      updateTeamState({
       events: response?.data?.data?.event_details,
       status_filtered_events: response?.data?.data?.event_details,
       type_filtered_events: response?.data?.data?.event_details,
       combined_filter: response?.data?.data?.event_details,
      })
    );
    // QA confirmed this endpoint does return hidden_count with team_id, and that
    // it is global rather than team-scoped - which is what the global badge and
    // the global archived page both want. Still read it defensively: defaulting
    // an absent field to 0 would wipe a count the dashboard had already fetched.
    const hiddenCount = response?.data?.data?.hidden_count;
    if (hiddenCount !== undefined && hiddenCount !== null) {
      dispatch(updateState({ archived_count: hiddenCount }));
    }
  }else {
    dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
  }
})
.catch((error) => {
  // console.error('error:', error);
  dispatch(updateTeamState({events_loading: false}))
  dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
});
}